import Vue from "vue";;
import "./assets/scss/module.scss";

import storage from "storejs";
import App from "./App";
import router from "./router";
import $ from "jquery";
import ElementUI from "element-ui";
import MintUI from "mint-ui";
import axios from "axios";
import VueDND from "awe-dnd";
Vue.use(VueDND);
// Vue.use(QRCode);
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(VueQuillEditor);

import "element-ui/lib/theme-chalk/index.css";
import "./assets/iconfont/iconfont.css";
import "./assets/css/install.less";

import "mint-ui/lib/style.css";
import "babel-polyfill";
import VueClipboard from "vue-clipboard2";

import message from "./mixins/message";
import "./plugins/day";
Vue.mixin(message);

Vue.use(ElementUI);
Vue.use(MintUI);

Vue.use(VueClipboard);
Vue.config.productionTip = false;
//全局字段
var uri = {
  url: "https://api.tuuux.com"
  // url: "http://www.tuuux.com"
  // url: "http://192.168.9.232:9099"
  // url: "http://192.168.9.232:8004"
  // url: "http://192.168.9.93:8088",
  // url: "http://192.168.0.173:8089",
  // url:"http://192.168.11.168"
  // url: "https://lp.cyb.yz.chewawa.com.cn"
};
const service = axios.create()
//配置请求默认路径
service.defaults.baseURL = uri.url;
//请求拦截器
service.interceptors.request.use(
  function(config) {
    console.log(config)
    //所有post.
    if (config.method == "post") {
      config.headers["Content-Type"] = "application/json; charset=utf-8";
    }
    if(config.url.indexOf('api/plug/checkVersion')>0){
      console.log('sss')
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }
    if (
      (config.url.indexOf("Login") < 0 &&
        config.url.indexOf("GetOwArticlesandworksNoLogin") < 0) ||
      config.url.indexOf("home") < 0
    ) {
      // config.headers['token'] = 'AAEAAAD/////AQAAAAAAAAAMAgAAAFRCb2xvb28uQ2hld2F3YS5BZGRpbm9sLldlYkFwaSwgVmVyc2lvbj0xLjAuMC4wLCBDdWx0dXJlPW5ldXRyYWwsIFB1YmxpY0tleVRva2VuPW51bGwFAQAAAB1Cb2xvb28uQ2hld2F3YS5BZGRpbm9sLlVUb2tlbgUAAAAUPFVJRD5rX19CYWNraW5nRmllbGQaPFNlc3Npb25JRD5rX19CYWNraW5nRmllbGQaPFRpbWVzdGFtcD5rX19CYWNraW5nRmllbGQaPFNpZ25hdHVyZT5rX19CYWNraW5nRmllbGQXPE9wZW5JZD5rX19CYWNraW5nRmllbGQAAQEBAQgCAAAAAQAAAAYDAAAAJGNkZmU2MTVlLWI2ZjctNDk4ZC1iZmQ2LWYxYzU5NDRkYmM2ZgYEAAAAJDNiNDlmMmMxLTI3NTktNDkzMC04YjQ1LWExZjc3MTg5NGY0ZAYFAAAALHRzbFlTazhlak9ncDRWUDNCK0NMMU13aEduRityMmp2TWZGRmJmeVA5eEU9BgYAAAAACw==';
      if (storage.get("PCToken")) {
        config.headers["token"] = storage.get("PCToken");
      }
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

//响应拦截器  --  统一错误处理等
service.interceptors.response.use(
  function(response) {
    //服务器拒绝访问
    if (
      (response.data.State == "4" && response.data.Msg == "token无效") ||
      (response.data.State == "9" &&
        response.data.Msg == "未登录或登录信息已过期，请重新登录。")
    ) {
      storage.clear();
      router.push({ path: "/" });
      return response.data;
    }
    return response.data;
  },
  function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

Vue.prototype.$storage = storage;

Vue.prototype.$axios = service;

// jquery的使用
window.$ = window.jQuery = $;
jQuery.support.cors = true;
// 小数点后一位

Vue.filter("numFilter", function(value) {
  let realVal = parseFloat(value).toFixed(1);
  return realVal;
});

var minute = 1000 * 60;
var hour = minute * 60;
var day = hour * 24;
function format(date, format) {
  if (typeof date == "string") {
    if (date.indexOf("T") >= 0) {
      date = date.replace("T", " ");
    }
    date = new Date(Date.parse(date.replace(/-/g, "/")));
  }else{
    date = new Date(date)
  }
  var o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "q+": Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds()
  };
  var w = [
    ["日", "一", "二", "三", "四", "五", "六"],
    ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
  ];
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  if (/(w+)/.test(format)) {
    format = format.replace(RegExp.$1, w[RegExp.$1.length - 1][date.getDay()]);
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return format;
}

// 计算时间差
function handleDate(minute, hour, day, dateTimeStamp) {
  var result = "";
  var newdateTimeStamp = new Date(dateTimeStamp).getTime();
  var now = new Date().getTime();
  var diffValue = now - newdateTimeStamp;
  if (diffValue < 0) {
    console.log("时间不对劲,服务器创建时间与当前时间不同步");
    return (result = "刚刚");
  }
  var dayC = diffValue / day;
  var hourC = diffValue / hour;
  var minC = diffValue / minute;
  if (parseInt(dayC) > 30) {
    result = "" + format(dateTimeStamp, "yyyy-MM-dd");
  } else if (parseInt(dayC) > 1) {
    result = "" + parseInt(dayC) + "天前";
  } else if (parseInt(dayC) == 1) {
    result = "昨天";
  } else if (hourC >= 1) {
    result = "" + parseInt(hourC) + "小时前";
  } else if (minC >= 5) {
    result = "" + parseInt(minC) + "分钟前";
  } else result = "刚刚";
  return result;
}

Vue.filter("timeFilterDayDate", function(value) {
  return handleDate(minute, hour, day, value);
});

function handleNumber(val) {
  if (val > 10000) {
    val = Math.round((val / 10000) * 100) / 100;
    val = val.toFixed(1);
    return val + "w";
  } else {
    return val;
  }
}
Vue.filter("numberFilter", function(value) {
  return handleNumber(value);
});

//时间过滤器， 取前16位数
Vue.filter("timeFilter", function(value) {
  if (!value || value == "") {
    return "";
  } else if (value.substr(0, 4) == "0001") {
    return "";
  } else {
    return value.replace(/T/g, " ").substring(0, 16);
  }
});

Vue.filter("timeFilterDate", function(value) {
  if (!value || value == "") {
    return "";
  } else if (value.substr(0, 4) == "0001") {
    return "";
  } else {
    return value.replace(/T/g, " ").substring(0, 19);
  }
});

Vue.filter("timeFilterT", function(value) {
  if (!value || value == "") {
    return "";
  } else if (value.substr(0, 4) == "0001") {
    return "";
  } else {
    return value.replace(/T/g, " ").substring(0, 10);
  }
});

Vue.filter("timeFilterTa", function(value) {
  if (value) {
    let date = new Date(value);
    let Y = date.getFullYear() + "年";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "月";
    let D =
      date.getDate() + 1 < 10 ? "0" + date.getDate() : date.getDate() + "日 ";
    let h =
      date.getHours() < 10
        ? "0" + date.getHours() + ":"
        : date.getHours() + ":";
    let m =
      date.getMinutes() < 10
        ? "0" + date.getMinutes() + ":"
        : date.getMinutes() + ":";
    let s =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
  }
});

Vue.filter("timeFilterDay", function(value) {
  if (value) {
    let date = new Date(value);
    let Y = date.getFullYear() + "年";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "月";
    let D = date.getDate() + "日 ";
    return Y + M + D;
  }
});

// Vue.prototype.$chooseLng = chooseLng;
// Vue.prototype.$chooseLat = chooseLat;
/* eslint-disable no-new */

new Vue({
  el: "#app",
  router,
  data: {
    eventHub: new Vue()
  },
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js